import { z } from 'zod';

export const sireFormSchema = z.object({
  name: z.string().min(1, 'Short Name is required'),
  breedId: z.string().min(1, 'Breed is required'),
  sire: z.string().min(1, 'Pedigree Name is required'),
  regPrefix: z.string().nullish(),
  registrationNumber: z.string().nullish(),
  sireTpi: z.number().optional(),
  sireCm: z.number().optional(),
  sireJpi: z.number().optional(),
  sireNm: z.number().optional(),
  cane: z.string().optional(),
  sexedCane: z.string().optional(),
  birth: z.date().optional().nullable(),
  heparin: z.number().optional(),
  breedReg: z.string().optional(),
  verified: z.enum(['Yes', 'No']).optional(),
});

export type SireFormValues = z.infer<typeof sireFormSchema>;
